import React, { useState } from 'react'

import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import HTMLWidget from '../../HTMLWidget'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { doneLoading, startLoading } from '../../../utils/loading'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { saveExpectedResult } from '../../../redux/actions/subProjectProposal'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import ButtonPanel from '../../ButtonPanel'
import { setAlertMessage } from '../../../utils/messageUtil'

export default function SubProjectExpectedResultWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveExpectedResult(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    formSchema.objects?.forEach((e) => {
      var value = data[e.name] || null

      // if(e.type == "DATE"){
      //   value =
      // }
      values.push({
        key: e.id,
        name: e.name,
        value: value,
        type: e.type,
      })
    })

    let request = {
      id: formSchema.id,
      values: values,
    }

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      <HTMLWidget
        style={{ marginTop: 10, marginBottom: 10, marginLeft: 10 }}
        data={formSchema.detail}
      />

      {isEdit && showCommandButton ? (
        <>
          <EditFormWidget
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            setLoading={setIsLoading}
          />
        </>
      ) : (
        <ViewFormWidget schema={formSchema} />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
